export default function AdblockAnalytics() {
  return null;
}
